function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".varukorg-thin_svg__st0{fill:none;stroke:currentColor;stroke-width:.5;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "varukorg-thin_svg__st0",
  d: "M.9 3.4l-.7 8.3h11.5L11 3.4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "varukorg-thin_svg__st0",
  d: "M6 .2C3.8.2 3.5 2.1 3.5 2.7v.7M6 .2c2.2 0 2.5 1.9 2.5 2.5v.7"
});

function SvgVarukorgThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "varukorg-thin_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 11.9 11.9",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgVarukorgThin;